import React from 'react';
import PropTypes from 'prop-types';

import FormCom from 'common/Form/FormCom';
import CaptchaContext from 'common/Form/FormWithCaptcha/CaptchaContext';
import useFormCaptchaState from 'common/Form/FormWithCaptcha/useFormCaptchaState';

const FormWithCaptcha = ({ additionalValues, formType, onError, ...props }) => {
  const initialCaptchaKey = formType?.optionalParams?.captchaKey;
  const initialCaptchaRequired = formType?.optionalParams?.captchaRequired;

  const captchaData = useFormCaptchaState(initialCaptchaKey, initialCaptchaRequired, onError);
  const { handleError, input: captchaInput } = captchaData;

  const mergedAdditionalValues = React.useMemo(() => {
    return Object.assign({}, additionalValues, { CAPTCHA_INPUT: captchaInput });
  }, [additionalValues, captchaInput]);

  return (
    <CaptchaContext.Provider value={captchaData}>
      <FormCom
        additionalValues={mergedAdditionalValues}
        buttonClassName="block"
        formType={formType}
        onError={handleError}
        {...props}
      />
    </CaptchaContext.Provider>
  );
};

FormWithCaptcha.propTypes = {
  additionalValues: PropTypes.arrayOf(PropTypes.object),
  formType: PropTypes.object,
  onError: PropTypes.func,
};

export default FormWithCaptcha;
